var exports = {
  "kL": "x04b3a21e--8130c7--container",
  "WL": "x04b3a21e--8130c7--factoids",
  "iW": "x04b3a21e--8130c7--main",
};

module.exports = exports;
